import { useCallback, useEffect, useState } from 'react';
import type { LanguageCode } from '@/types';

const STORAGE_KEY = 'visitkiosk.lang';
const SUPPORTED: LanguageCode[] = ['hu', 'en', 'de'];
const DEFAULT_LANG: LanguageCode = 'hu';

function readStoredLanguage(): LanguageCode {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return (SUPPORTED as string[]).includes(stored ?? '') ? (stored as LanguageCode) : DEFAULT_LANG;
}

export function useLanguage() {
  const [lang, setLangState] = useState<LanguageCode>(readStoredLanguage);

  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const setLang = useCallback((next: LanguageCode) => {
    setLangState(next);
  }, []);

  return { lang, setLang, supported: SUPPORTED };
}
